import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function WRHowItWorks() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-2352">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-2353">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-2354">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-2355">
            HOW DO WRINKLE RELAXERS WORK?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-2356"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-2357">
            Wrinkle relaxers are neuromodulators that weaken and temporarily
            relax muscle activity in the face and neck.
          </p>

          {/* Pull Quote */}
          <div className="relative max-w-[700px] mx-auto mb-12 text-left pl-6 lg:pl-10 border-l-4 border-[#FF1493]" data-id="element-2358">
            <div className="absolute -top-4 -left-4 lg:-left-6 text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-50" data-id="element-2359">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[20px] leading-[1.6] relative z-10" data-id="element-2360">
              The neurotoxins in these injectables stop the underlying muscle
              from contracting, so it stops putting repeated tension on the
              overlying facial skin. This is especially helpful as we age,
              because our skin doesn't bounce back like it used to!
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body text-center" data-id="element-2361">
            <p data-id="element-2362">
              Neurotoxins are the key to keeping wrinkle-free skin. Start them
              young enough as part of your preventative skincare routine because
              once you start to see etched in lines, it's too late.
            </p>
            <p data-id="element-2363">
              At Be CLINICAL, we don't want you to think for one second that
              neurotoxins can make a person look too fake. Usually it's much
              more about the overuse or poor placement of dermal fillers that
              can give someone an unnatural appearance. At Be CLINICAL, we want
              you to look fabulous forever without anyone knowing that you've
              had anything 'done.'
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}